import Temp from '@/courier/Temp'

export default class TrueELogistics extends Temp {

    static CODE = 'TRUE';

    constructor() {
        super( TrueELogistics.CODE ); 
    }

    getZone( item ){
        let type , to
        let cross_price = 0
        let remote_area = 0

        let prefixToPostCode = item.toPostcode.toString().substring( 0 , 2 )
        to = super.checkZone( prefixToPostCode );
        if (to == 1) {
          type = 1
        } else {
          type = 2
        }

        return {
            rate_type : type ,
            rate_remote_area : remote_area ,
            cross_price : cross_price
        }
    }

    checkWeight( courierRates , item , validate ){
        item.index = courierRates.findIndex(rate => {
            return item.weight >= rate.min && item.weight <= rate.max
        })

        return super.checkRules( item , validate );
    }

    checkDimension( dimensionCourier , item , validate ){
        return super.checkCourierDimension( dimensionCourier , item , validate );
    }

}